<template>
	<div>
		<div class="panel panel-faq">
			<div class="container">
				<div class="panel-heading">
					<h3 class="panel-title">回收常见问题</h3>
				</div>
				<div class="faq-group clearfix">
					<ul class="pull-left">
						<li v-for="(item,index) in problemList" :key='index' v-if="index < 3">
							<h5>
								<strong>{{index+1}}、</strong>
								{{item.article_title}}
							</h5>
							<div class="faq-content">
								<p v-html="item.article_content"></p>
							</div>
						</li>
					</ul>
					<ul class="pull-right">
						<li v-for="(item,index) in problemList" :key='index' v-if="index>=3 && index<7">
							<h5>
								<strong>{{index+1}}、</strong>
								{{item.article_title}}
							</h5>
							<div class="faq-content">
								<p v-html="item.article_content"></p>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name:"problem",
		data(){
			return{
				problemList:[

				],
			}
		},
		created() {
			this.problem()
		},
		methods:{
			problem() {
				// localStorage.setItem("token","4564654")
				let token = localStorage.getItem('token')
					this.$api.issue({
							token:token,
              id: 2,
					}).then(res => {
							if(res.code === 1){
								for(let i=0;i<res.data.length;i++){
									res.data[i].article_content = this.HTMLDecode(res.data[i].article_content)
									this.problemList.push(res.data[i])
								}
							}
					})
			},
			HTMLDecode(text) {
				var temp = document.createElement("div");
				temp.innerHTML = text;
				var output = temp.innerText || temp.textContent;
				temp = null;
				return output;
			},
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/common/problem/index.vue